import React, { Component } from 'react'
import FilteredList2 from './filteredList2'
import TransactionForm from './transactionForm'
import { getParams, end_point } from './helper'
var $ = require('jquery')


class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterableFields: [
        "athlete.first_name", 
        "athlete.last_name", 
        "parent.first_name", 
        "parent.last_name", 
        "program.ages", 
        "program.division", 
        "program.group_name", 
        "plan.plan_name", 
        "price_breakdown.promo_code_key", 
        "price_breakdown.total",  
        "create_date", 
        "payment_gateway.status.status", 
        "payment_gateway.enrollment_status", 
        "price_breakdown.promo_code", 
        "user.first_name", 
        "user.last_name"],
        
      labelFields: [
        { "displayName":"Type", "name":`program.type`, "size": "6%"},
        { "displayName":"Account Holder", "name":`account_holder`, "size": "12%"},
        { "displayName":"Participant", "name":"athlete.first_name", "size": "14%"},
        { "displayName":"Group", "name":"program.ages", "size": "14%"},
        { "displayName":"Group Name Name", "name":"program.group_name", "size": "19%"},
        { "displayName":"Plan Name", "name":"plan.plan_name", "size": "12%"},
        // { "displayName":"Promo", "name":"price_breakdown.promo_code_key", "size": "6%"},
        { "displayName":"Total", "name":"price_breakdown.total", "size": "5%"},
        { "displayName":"Status", "name":"payment_gateway.status.status", "size": "8%"},
        { "displayName":"Create Date", "name":"create_date", "size": "10%"}
      ],
      endpoint: `${end_point('transactions')}/transactions`,
      organization_merch: []
    }
    console.log('*** TRANSACTIONS, PROPS=',this.props)
  }

  componentDidMount() {
    $.ajax({
      headers: {
        "token": getParams().jwt,
        "organization_id": localStorage.getItem("organization_id")
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('organizations')}/organizations`,
    }).then(data => this.setState({organization_merch: data.merch, payment_credentials: data.payment_credentials}))
  }


  render() {
    return (
      <FilteredList2 
          organization_merch={this.state.organization_merch} 
          heading="Transactions" 
          filterableFields={this.state.filterableFields} 
          labelFields={this.state.labelFields} 
          endpoint={this.state.endpoint}
          modalClassName="transactions-modal-shell">
        <TransactionForm 
          organization_merch={this.state.organization_merch}
          payment_credentials={this.state.payment_credentials}
        />
      </FilteredList2>
    );
  }
}

export default Transactions;
